module.exports = __webpack_public_path__ + "img/Im2.c631816d.png";